import React, { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { useSelector } from 'react-redux';
import { formatPrice, formatPricewithdecimal } from "../NumberFormat";
import { withTranslation } from "react-i18next";
import UseBodyScrollLock from "./UseBodyScrollLock.js";
import ErrorCodePopup from "./ErrorCodePopup.js";

const BetSuccessPopup = (props) => {
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const { onClose, response, getGameId } = props;
  const [successData, setDataSuccess] = useState([]);
  const [faildData, setDataFaild] = useState([]);

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState('')
  const [totalPayUser, setTotalPayUser] = useState(0)

  let gameid = getGameId ? getGameId : gameId
  const showData = true;
  UseBodyScrollLock(showData);

  useEffect(() => {
    let newRespSuccessArray = [];
    let newRespFailedArray = [];
    if (response.length > 0) {
      const gametype = response[0].gametype;
      if (gametype === "quickbuy") {
        setDataSuccess(response[0].datasuccess[gameid]['4d3d2d']);
      } else {
        response.map((array, index) => {
          if (array.datasuccess) {
            array.datasuccess[gameid].map((sucVal) => {
              newRespSuccessArray.push(sucVal)
            })
            setTotalPayUser((prev) => {
              return prev + array.totalbayar
            })
          }
          if (array.datafailed) {
            array.datafailed[gameid].map((errVal) => {
              newRespFailedArray.push(errVal)
            })
          }
        })
        setDataSuccess(newRespSuccessArray);
        setDataFaild(newRespFailedArray);
      }
    }
  }, [response, gameid]);

  const handlePopupOpen = (redValue) => {
    let message;
    let code = '';
    code = 'code' + redValue;
    let popupMessage = props.t(code);
    setPopupMessage(popupMessage);
    setIsPopupOpen(true);
  };

  const handlePopupClose = () => {
    setIsPopupOpen(false);
    setPopupMessage('');
  };

  return (
    <>
      {
        showData &&
        <div className="overlay">
          <div className='overlay_innerDiv' onClick={onClose}></div>
          <div className="informasi_popup">
            <div className="betdeskon_popup_header">
              <p className="process_txt">
                {/* {props.t('process_done')} ({response[0].processLabel ? response[0].processLabel : ''} - {response[0].game_name}) */}
                {props.t('process_done')} ({response[0].processLabel ? response[0].processLabel : (response[0].gametype === 'quickbuy' ? 'QUICK BUY' : response[0].gametype)} - {response[0].game_name})
              </p>
              <button className="betdeskon_popup-close" onClick={onClose}>
                <IoMdClose className="btnclose" />
              </button>
            </div>
            <div className="informasi_popup_body">
              {faildData.length > 0 && (
                <>
                  <div className="result_txt">
                    {props.t('period')} : <span className="header_txt">{response[0].nextPeriode} - {response[0].game_code}</span> {props.t('Cancelled')}
                  </div>
                  <div className="betdeskonwrapper">
                    <div className="betdeskon_container">
                      <div className="betdeskoncontainer">
                        <table>
                          <thead>
                            <tr className="Heading">
                              <th>No</th>
                              {
                                response[0].gametype === "colokbebas2d" ?
                                  <>
                                    <th>{props.t('bet')} 1</th>
                                    <th>{props.t('bet')} 2</th>
                                  </>
                                  :
                                  response[0].gametype === "kombinasi" ?
                                    <>
                                      <th>{props.t('bet')} 1</th>
                                      <th>{props.t('bet')} 2</th>
                                    </>
                                    :
                                    response[0].gametype === "coloknaga" ?
                                      <>
                                        <th>{props.t('bet')} 1</th>
                                        <th>{props.t('bet')} 2</th>
                                        <th>{props.t('bet')} 3</th>
                                      </>
                                      :
                                      <th>{props.t('bet')}</th>}
                              {
                                response[0].gametype !== "colokbebas" && response[0].gametype !== "colokbebas2d" && response[0].gametype !== "coloknaga" &&
                                response[0].gametype !== "shio" && response[0].gametype !== "tengahtepi" &&
                                response[0].gametype !== "dasar" && response[0].gametype !== "kombinasi" && response[0].gametype !== "silanghomo" && response[0].gametype !== "kembangkempis" &&
                                <th>{props.t('position')}</th>
                              }
                              <th>{props.t('amount')}</th>
                              <th>{props.t('error_code')}</th>
                              <th>{props.t('description')}</th>
                            </tr>
                          </thead>
                          <tbody className="scrollable-tbody">
                            {faildData?.map((item, index) => (
                              <tr key={index} className={index % 2 === 0 ? "even-row" : "odd-row"}>
                                <td className="inputs">{index + 1}</td>
                                {
                                  response[0].gametype === "colokbebas2d" ?
                                    <>
                                      <td className="inputs"><strike>{item.bet}</strike></td>
                                      <td className="inputs"><strike>{item.bet2}</strike></td>
                                    </>
                                    :
                                    response[0].gametype === "kombinasi" ?
                                      <>
                                        <td className="inputs"><strike>{item.bet}</strike></td>
                                        <td className="inputs"><strike>{item.bet2}</strike></td>
                                      </>
                                      :
                                      response[0].gametype === "colokbebas" ?
                                        <td className="inputs"><strike>{item.bet}</strike></td> :
                                        response[0].gametype === "coloknaga" ?
                                          <>
                                            <td className="inputs"><strike>{item.bet}</strike></td>
                                            <td className="inputs"><strike>{item.bet2}</strike></td>
                                            <td className="inputs"><strike>{item.bet3}</strike></td>
                                          </>
                                          :
                                          <td className="inputs"><strike>{item.bet}</strike></td>
                                }
                                {
                                  response[0].gametype !== "colokbebas" && response[0].gametype !== "colokbebas2d" &&
                                  response[0].gametype !== "coloknaga" && response[0].gametype !== "shio" && response[0].gametype !== "tengahtepi" &&
                                  response[0].gametype !== "dasar" && response[0].gametype !== "kombinasi" &&
                                  response[0].gametype !== "quickbuy" &&
                                  // <td className="inputs">{item.bet_type}</td>
                                  <td className="inputs">{response[0].gametype == "colokjitu" ? item.posisi : item.bet_type}</td>
                                }
                                <td className="inputs">
                                  <strike>{item.amount}</strike>
                                </td>
                                <td className="inputs" style={{ cursor: "pointer" }}>
                                  {/* <a >{props.t('click_here')} ({item.red})2</a> */}
                                  <a className="link" onClick={() => handlePopupOpen(item.red)}>
                                    {props.t('click_here')} ({item.red})
                                  </a>
                                </td>
                                <td className="inputs" style={{ color: 'red' }}>
                                  {item.red == 14 ? props.t("Removed") : props.t("Eliminate")}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {successData?.length > 0 && (
                <>
                  <div className="result_txt">
                    {props.t('period')}: {response[0].nextPeriode} - {response[0].game_code} {props.t('sucess')}
                  </div>
                  <div
                  // className="betdeskonwrapper"
                  >
                    <div className="betdeskon_container">
                      <div className="betdeskoncontainer">
                        <table>
                          <thead>
                            <tr className="Heading">
                              <th>No</th>
                              {
                                response[0].gametype === "colokbebas2d" ?
                                  <>
                                    <th>{props.t('bet')} 1</th>
                                    <th>{props.t('bet')} 2</th>
                                  </>
                                  :
                                  response[0].gametype === "kombinasi" ?
                                    <>
                                      <th>{props.t('bet')} 1</th>
                                      <th>{props.t('bet')} 2</th>
                                    </>
                                    :
                                    response[0].gametype === "coloknaga" ?
                                      <>
                                        <th>{props.t('bet')} 1</th>
                                        <th>{props.t('bet')} 2</th>
                                        <th>{props.t('bet')} 3</th>
                                      </>
                                      :
                                      <th>{props.t('bet')}</th>}
                              {
                                response[0].gametype !== "colokbebas" && response[0].gametype !== "colokbebas2d" && response[0].gametype !== "coloknaga" &&
                                response[0].gametype !== "shio" && response[0].gametype !== "tengahtepi" &&
                                response[0].gametype !== "dasar" && response[0].gametype !== "kombinasi" && response[0].gametype !== "silanghomo" && response[0].gametype !== "kembangkempis" &&
                                response[0].gametype !== "quickbuy" &&
                                <th>{props.t('position')}</th>
                              }
                              <th>{props.t('amount')}</th>
                              {
                                response[0].gametype === "tengahtepi" || response[0].gametype === "dasar" || response[0].gametype === "silanghomo" && response[0].gametype === "kembangkempis" ?
                                  <th>Kei (%)</th> : ""
                              }
                              <th>{props.t('discount')} (%)</th>
                              <th>{props.t('pay')}</th>
                              <th>{props.t('totalWin')}</th>
                            </tr>
                          </thead>
                          <tbody className="scrollable-tbody">
                            {successData?.map((item, index) => (
                              <tr key={index} className={index % 2 === 0 ? "even-row" : "odd-row"}>
                                <td className="inputs">{index + 1}</td>
                                {
                                  response[0].gametype === "colokbebas2d" ?
                                    <>
                                      <td className="inputs">{item.bet}</td>
                                      <td className="inputs">{item.bet2}</td>
                                    </>
                                    :
                                    response[0].gametype === "kombinasi" ?
                                      <>
                                        <td className="inputs">{item.bet}</td>
                                        <td className="inputs">{item.bet2}</td>
                                      </>
                                      :
                                      response[0].gametype === "colokbebas" ?
                                        <td className="inputs">{item.bet}</td> :
                                        response[0].gametype === "coloknaga" ?
                                          <>
                                            <td className="inputs">{item.bet}</td>
                                            <td className="inputs">{item.bet2}</td>
                                            <td className="inputs">{item.bet3}</td>
                                          </>
                                          :
                                          <td className="inputs">{item.bet}</td>}
                                {
                                  response[0].gametype !== "colokbebas" && response[0].gametype !== "colokbebas2d" &&
                                  response[0].gametype !== "coloknaga" && response[0].gametype !== "shio" && response[0].gametype !== "tengahtepi" &&
                                  response[0].gametype !== "dasar" && response[0].gametype !== "kombinasi" && response[0].gametype !== "silanghomo" && response[0].gametype !== "kembangkempis" && 
                                  response[0].gametype !== "quickbuy" &&
                                  // <td className="inputs">{item.bet_type}</td>
                                  <td className="inputs">{response[0].gametype == "colokjitu" ? item.posisi : item.bet_type}</td>
                                }
                                {/* {
                            response[0].gametype !== "colokbebas" ?
                              <td className="inputs">{item.bet_type}</td> : ""
                          } */}
                                <td className="inputs">{(response[0].gametype === "colokbebas" || response[0].gametype === "colokbebas2d" || response[0].gametype === "colokjitu" ||
                                  response[0].gametype === "coloknaga" || response[0].gametype === "shio" || response[0].gametype === "tengahtepi" ||
                                  response[0].gametype === "dasar" || response[0].gametype === "kombinasi") ? formatPricewithdecimal(item.amount) : formatPrice(item.amount)}</td>
                                {
                                  response[0].gametype === "tengahtepi" || response[0].gametype === "dasar" || response[0].gametype === "silanghomo" && response[0].gametype === "kembangkempis" ?
                                    <td className="inputs">{item.kei}%</td> : ""
                                }
                                <td className="inputs">{item.disc}%</td>
                                <td className="inputs">{(response[0].gametype === "colokbebas" || response[0].gametype === "colokbebas2d" ||
                                  response[0].gametype === "colokjitu" || response[0].gametype === "coloknaga" || response[0].gametype === "shio" || response[0].gametype === "tengahtepi" ||
                                  response[0].gametype === "dasar" || response[0].gametype === "kombinasi") ? formatPricewithdecimal(item.bayar) : Number.isInteger(formatPrice(item.bayar)) ? (formatPrice(item.bayar)) : (formatPrice(item.bayar) % 1 !== 0) ? (formatPricewithdecimal(item.bayar)) : formatPrice(item.bayar)}</td>
                                <td className="inputs">{(response[0].gametype === "colokbebas" || response[0].gametype === "colokbebas2d" ||
                                  response[0].gametype === "colokjitu" || response[0].gametype === "coloknaga" || response[0].gametype === "shio" || response[0].gametype === "tengahtepi" ||
                                  response[0].gametype === "dasar" || response[0].gametype === "kombinasi") ? formatPricewithdecimal(item.totalWin) : formatPrice(item.totalWin)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </>
              )}
              <div className="total_plyer_count">Total {props.t('player_pay')}: {(response[0].gametype === "quickbuy" || response[0].gametype === "colokbebas" || response[0].gametype === "colokbebas2d" ||
                response[0].gametype === "colokjitu" || response[0].gametype === "coloknaga" || response[0].gametype === "shio" || response[0].gametype === "tengahtepi" ||
                response[0].gametype === "dasar" || response[0].gametype === "kombinasi") ? formatPricewithdecimal(response[0].totalbayar) : formatPricewithdecimal(totalPayUser)}</div>
            </div>
          </div>
          {isPopupOpen &&
            (<ErrorCodePopup onClose={handlePopupClose} message={popupMessage} />)
          }
        </div>
      }
    </>

  );
};

export default withTranslation()(BetSuccessPopup);
